import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ImageCropperModule } from 'ngx-image-cropper';
import { WebcamModule } from 'ngx-webcam';
import { MatIconModule } from '@angular/material/icon';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { DragDropSelectFileComponent } from '../sessions/session/upload/drag-drop-select-file/drag-drop-select-file.component';
import { UploadPDFComputerComponent } from '../sessions/session/upload/upload-pdf-computer/upload-pdf-computer.component';
import { UploadPdfPreparingDocumentComponent } from '../sessions/session/upload/upload-pdf-computer/upload-pdf-preparing-document/upload-pdf-preparing-document.component';
import { PreviewPageItemComponent } from '../sessions/session/upload/upload-pdf-computer/pdf-preview-selector/preview-page-item/preview-page-item.component';
import { PdfPreviewSelectorComponent } from '../sessions/session/upload/upload-pdf-computer/pdf-preview-selector/pdf-preview-selector.component';
import { UploadPdfSelectBoardStrategyComponent } from '../sessions/session/upload/upload-pdf-computer/upload-pdf-select-board-strategy/upload-pdf-select-board-strategy.component';
import { LoadPdfAndPreviewComponent } from '../sessions/session/upload/upload-pdf-computer/load-pdf-and-preview/load-pdf-and-preview.component';
import { UploadComponent } from '../dialogs/upload/upload/upload.component';
import { RadioSelectionComponent } from '../standalones/components/radio-selection/radio-selection.component';
import { PencilIconComponent } from '../standalones/components/pencil-icon/pencil-icon.component';
import { PencilButtonComponent } from '../standalones/components/pencil-button/pencil-button.component';
import { GenericFilterComponent } from '../standalones/components/generic-filters-view/generic-filters-view.component';
import { AppliedFilterPillsComponent } from '../standalones/components/applied-filters/applied-filter-pills.component';
import { SVGIconComponentsModule } from '../common/svg-icon/svg-icon-components.module';
import { FilesExtensionComponent } from '../content/files/files-extension/files-extension.component';
import { ExtendedGridViewComponent } from '../content/files/files-extension/extended-grid-view/extended-grid-view.component';
import { TooltipDirective } from '../standalones/directives/pncl-tooltip.directive';
import { UiModule } from '../ui/ui.module';
import { PipeModule } from '../pipes/pipes.module';
import { ExtendedListViewComponent } from '../content/files/files-extension/extended-list-view/extended-list-view.component';
import { DirectivesModule } from '../directives/directives.module';
import { UploadPanelComponent } from '../sessions/session/upload/upload-panel/upload-panel.component';
import { ChromeCanvasBugWorkaroundDirective } from '../standalones/directives/chrom-canvas-bug-workaround.directive';
import { NewLoadPdfAndPreviewComponent } from '../sessions/session/upload/upload-pdf-computer/new-load-pdf-and-preview/new-load-pdf-and-preview.component';
import { NewPreviewPageItemComponent } from '../sessions/session/upload/upload-pdf-computer/pdf-preview-selector/new-preview-page-item/new-preview-page-item.component';
import { BulkUploadPanelComponent } from '../sessions/session/upload/bulk-upload-panel/bulk-upload-panel.component';
import { BulkUploadDropComponent } from '../sessions/session/upload/bulk-upload-panel/bulk-upload-drop/bulk-upload-drop.component';
import { BulkUploadProcessingComponent } from '../sessions/session/upload/bulk-upload-panel/bulk-upload-processing/bulk-upload-processing.component';
import { BulkUploadPageSelectionComponent } from '../sessions/session/upload/bulk-upload-panel/bulk-upload-page-selection/bulk-upload-page-selection.component';
import { BulkUploadPdfPreviewSelectorComponent } from '../sessions/session/upload/bulk-upload-panel/bulk-upload-pdf-preview-selector/bulk-upload-pdf-preview-selector.component';
import { BulkUploadInsertionStrategyComponent } from '../sessions/session/upload/bulk-upload-panel/bulk-upload-insertion-strategy/bulk-upload-insertion-strategy.component';
import { BulkUploadArrangementComponent } from '../sessions/session/upload/bulk-upload-panel/bulk-upload-arrangement/bulk-upload-arrangement.component';

@NgModule({
  declarations: [
    DragDropSelectFileComponent,
    UploadPDFComputerComponent,
    UploadPdfPreparingDocumentComponent,
    PreviewPageItemComponent,
    NewPreviewPageItemComponent,
    PdfPreviewSelectorComponent,
    UploadPdfSelectBoardStrategyComponent,
    LoadPdfAndPreviewComponent,
    NewLoadPdfAndPreviewComponent,
    UploadComponent,
    UploadPanelComponent,
    BulkUploadPanelComponent,
    BulkUploadDropComponent,
    BulkUploadProcessingComponent,
    BulkUploadPageSelectionComponent,
    BulkUploadPdfPreviewSelectorComponent,
    BulkUploadInsertionStrategyComponent,
    BulkUploadArrangementComponent,
    FilesExtensionComponent,
    ExtendedGridViewComponent,
    ExtendedListViewComponent,
  ],
  imports: [
    CommonModule,
    MatProgressBarModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatIconModule,
    TranslateModule,
    NgbTooltipModule,
    ImageCropperModule,
    WebcamModule,
    InfiniteScrollModule,
    RadioSelectionComponent,
    PencilIconComponent,
    PencilButtonComponent,
    GenericFilterComponent,
    AppliedFilterPillsComponent,
    SVGIconComponentsModule,
    TooltipDirective,
    UiModule,
    PipeModule,
    OverlayModule,
    MatButtonModule,
    MatCheckboxModule,
    FormsModule,
    DirectivesModule,
    ChromeCanvasBugWorkaroundDirective,
    MatExpansionModule,
  ],
  exports: [UploadComponent, UploadPanelComponent],
})
export class UploadModule {}
